import { Collapse as BaseCollapse } from "antd";
import styled, { css } from "styled-components";
import color from "../_style/color";

const types = {
  basic: css`
    background-color: ${color.light};

    .ant-collapse-header {
      color: ${color.nightRider};
    }
  `,
};

const Collapse = styled(BaseCollapse).attrs((props) => ({
  type: props.type || "basic",
}))`
  ${({ type }) => types[type]}
`;
export default Collapse;
